import React from 'react';
import Home from './pages/Home';
import './styles/global.css';

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
